// import waiter from '../../../assets/img/waiter.svg';
import {ReactComponent as Waiter} from '../../../assets/img/waiter.svg';

export default function Loader() {

    return <div className="loader">
        <Waiter style={{width: 50, height: 50}} />
    </div>
}